import { WithProviders } from './providers'
import './styles.scss'

import '@fontsource/manrope/300.css'
import '@fontsource/manrope/400.css'
import '@fontsource/manrope/500.css'
import '@fontsource/manrope/700.css'
import { MainPage } from '~pages/main'
import { PageWrapper } from './wrapper/pageWrapper'

const App = () => {
	return (
		<WithProviders>
			<PageWrapper>
				<MainPage />
			</PageWrapper>
		</WithProviders>
	)
}

export default App
